module.exports = {
	"articleTitle1": "Campus Character: Quickie Burger owner Kerope Arman",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Quickie Burger",
	"totalMisc": 0,
	"articleLink2": "https://www.michigandaily.com/content/burger-joints-name-logo-irks-lgbt-group",
	"articleSnippet1": "Mar 2, 2009 ... Quickie Burger owner Kerope Arman has seen his fair share of intoxicated \nstudents with the munchies for fast food. Conveniently located at the ...",
	"articleSnippet2": "Mar 20, 2008 ... When the owners of Quickie Burger and Dogs chose their logo, they thought it \nwould make patrons crave an order of chili cheese fries. But the ...",
	"articleLink1": "https://www.michigandaily.com/content/2009-03-03/campus-character-quickie-burger-owner-kerope-arman",
	"articleTitle2": "Burger joint's name, logo irks LGBT group",
	"address": "800 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.271733,
		"lng": -83.740905
	},
	"foodRecommendations": [],
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/quickieburger.json
// module id = 954
// module chunks = 0